'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isPreviousDisabled = isPreviousDisabled;
exports.isNextDisabled = isNextDisabled;
exports.pageRange = pageRange;

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isPreviousDisabled(page) {
  return page <= 1;
}

function isNextDisabled(page, pages) {
  return page >= pages;
}

function pageRange(page, pages) {
  var startPage = void 0;
  var endPage = void 0;
  var potentialLastPage = page + 3;

  if (page <= 5) {
    startPage = 1;
    endPage = _lodash2.default.min([7, pages]);
  } else if (page >= pages - 5) {
    startPage = _lodash2.default.max([1, pages - 6]);
    endPage = pages;
  } else {
    startPage = page - 3;
    endPage = _lodash2.default.min([potentialLastPage, pages]);
  }

  return _lodash2.default.range(startPage, endPage + 1);
}


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/utils-pagination/lib/index.js
// module id = 1565
// module chunks = 1